namespace GeniuzPOS.ReportMasterData {
    export interface DocDaterequest extends Serenity.ListRequest {
        StartDate?: string;
        EndDate?: string;
    }
}
